const primaryLinks = document.querySelectorAll('.navigation__item.hover-link');

Array.prototype.forEach.call(primaryLinks, primaryLink => {

    primaryLink.addEventListener('click', e => {
       if(!primaryLink.classList.contains('active')) {
           e.preventDefault();
           Array.prototype.forEach.call(primaryLinks, el => el.classList.remove('active'));
           primaryLink.classList.add('active');
       }
    });

    const secondaryLinks = primaryLink.querySelectorAll('.navigation-secondary__item.hover-link');
    Array.prototype.forEach.call(secondaryLinks, secondaryLink=> {
        secondaryLink.addEventListener('click', e => {
            if (!secondaryLink.classList.contains('active')) {
                e.preventDefault();
                Array.prototype.forEach.call(secondaryLinks, el => el.classList.remove('active'));
                secondaryLink.classList.add('active');
            }
        });
    });
});
